<template>
  <div class="status-bar">
    <FarmStatusCard :farm="farm"></FarmStatusCard>
    <div class="farm-window status-card">
      <div class="stat-bars">
        <p><b>Money</b></p>
        <div class="option-buttons">
          <p style="text-align: left;">$ {{ (Math.floor(farm.state.money)).toFixed(0) }} </p>
        </div>

        <p><b>Milk</b></p>
        <div class="option-buttons">
          <ValueMeter :container="farm.state.milk" barColor="#abc" style="border-right: 0;">
            <p class="milk-label">
              {{ farm.state.milk.value.toFixed(1) }} / {{ farm.state.milk.max.toFixed(1) }} L
            </p>
          </ValueMeter>
          <template v-if="farm.state.market.sellCooldown.fraction === 0">
            <TextButton class="farm-button" @click="farm.sell()">
              <p>
                <b>Sell </b>
                <span>(max {{ farm.state.market.predictSaleAmount(farm.state.milkPrice.value).toFixed(1) }} L)</span>
              </p>
            </TextButton>
          </template>
          <template v-else>
            <TextButton class="farm-button disabled-button">
              <p>
                <b>{{ util.displayTime(farm.state.market.sellCooldown.value) }}</b>
              </p>
            </TextButton>
          </template>
        </div>

        <p><b>Lab Status</b></p>
        <div class="option-buttons">
          <ValueMeter :container="farm.state.lab.currentResearchProgress" barColor="#741a32">
            <p class="milk-label">
              <span v-if="farm.state.lab.currentResearch !== undefined">{{ farm.state.lab.currentResearch.name }}</span>
              <span v-else>No research</span>
              <span> ({{ (farm.state.lab.labPower * 60).toFixed(0) }} sci/day)</span>
            </p>
          </ValueMeter>
        </div>

      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import EmployeeCard from '@/components/EmployeeCard.vue'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import Laboratory from '@/farm/Laboratory'
import ResearchCard from '@/components/ResearchCard.vue'
import Research from '@/Research'
import FarmStatusCard from '@/components/FarmStatusCard.vue'
import TextButton from '@/components/ui/TextButton.vue'
import util from '@/util'

@Options({
  components: {
    ResearchCard, ValueMeter, FarmStatusCard, TextButton
  },
  props: {
    farm: Farm
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    }
  },
  computed: {
    util() {
      return util
    }
  }
})
export default class StatusBar extends Vue {
  farm!: Farm
}
</script>

<style scoped lang="scss">
  .status-bar {
    grid-column: 1 / 13;

    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    grid-auto-rows: 1fr;
    grid-gap: 10px;

    //max-width: 1000px;
    //margin-bottom: 10px;
    //margin-left: auto;
    //margin-right: auto;

    @media only screen and (max-width: $mobile-width) {
      grid-template-columns: 1fr;
    }
  }

  .stat-bars {
    display: grid;
    grid-template-columns: 100px 1fr;
    grid-auto-rows: 30px;
    grid-gap: 0px;

    .value-meter {
      margin-top: auto;
      margin-bottom: auto;
      height: 80%;
    }

    p {
      margin-top: auto;
      margin-bottom: auto;
    }
  }

  .option-buttons {
    display: grid;
    grid-auto-columns: 3fr 2fr;
    grid-auto-flow: column;

    p {
      text-align: center;
    }

    .text-button {
      display: table;
      border: $component-border-style;
      //border-right: 0;
      height: 80%;
      margin-top: auto;
      margin-bottom: auto;

      //&:last-child {
      //  border: $component-border-style;
      //}

      p {
        display: table-cell;
        vertical-align: middle;
      }
    }
  }
</style>
